import useLastReadActivityKey from '../providers/ActivityAcknowledgement/useLastReadActivityKey';

export default useLastReadActivityKey;
